/* ============================================================
   Accessory Product — gallery + variant selection + live pricing
   Options: Stone (swatches) | Size (cards, static) | Count (pills)
   No finish / edge / base surcharges. No bundle upgrades.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- money formatting (Shopify-style) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}}';

    function defaultTo(num, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = defaultTo(cents, 0, ' ', ''); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  /* ---------- per-section init ---------- */
  function initSection(root) {
    if (root.dataset.apInit) return;
    root.dataset.apInit = '1';

    var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-mp-variants]').textContent);
    } catch (e) { variants = []; }

    var inventoryMap = {};
    try {
      var invEl = root.querySelector('[data-mp-inventory]');
      if (invEl) inventoryMap = JSON.parse(invEl.textContent || '{}');
    } catch (e) { inventoryMap = {}; }

    function handleize(str) {
      return String(str || '').toLowerCase().trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    /* ===== GALLERY ===== */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mp-thumb]'));
    var current = 0;

    function groupOf(el) { return el.getAttribute('data-mp-group') || 'default'; }

    function visibleIndices() {
      var out = [];
      slides.forEach(function (s, i) {
        if (!s.classList.contains('is-hidden')) out.push(i);
      });
      return out;
    }

    function showSlide(i) {
      var vis = visibleIndices();
      if (!vis.length) return;
      if (vis.indexOf(i) === -1) i = vis[0];
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      current = i;
    }

    function step(dir) {
      var vis = visibleIndices();
      if (!vis.length) return;
      var pos = vis.indexOf(current);
      if (pos === -1) pos = 0;
      pos = (pos + dir + vis.length) % vis.length;
      showSlide(vis[pos]);
    }

    /* show only the image set for a stone; fall back to the 'default' set */
    function setImageGroup(group) {
      if (!slides.length) return;
      var hasGroup = slides.some(function (s) { return groupOf(s) === group; });
      var hasDefault = slides.some(function (s) { return groupOf(s) === 'default'; });
      var useGroup = hasGroup ? group : 'default';
      slides.forEach(function (s, i) {
        var on = (hasGroup || hasDefault) ? (groupOf(s) === useGroup) : true;
        s.classList.toggle('is-hidden', !on);
        if (thumbs[i]) thumbs[i].classList.toggle('is-hidden', !on);
      });
      var vis = visibleIndices();
      if (vis.length) showSlide(vis[0]);
    }

    var prevBtn = root.querySelector('[data-mp-prev]');
    var nextBtn = root.querySelector('[data-mp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        showSlide(parseInt(t.dataset.mpThumb, 10));
      });
    });

    /* swipe gestures on viewport (mobile) */
    var viewport = root.querySelector('[data-mp-viewport]');
    if (viewport) {
      var SWIPE_THRESHOLD = 40;
      var startX = 0;
      var startY = 0;
      var tracking = false;

      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      viewport.addEventListener('touchend', function (e) {
        if (!tracking || !e.changedTouches || !e.changedTouches[0]) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          step(dx < 0 ? 1 : -1);
        }
      }, { passive: true });

      viewport.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    }

    /* ===== VARIANT SELECTION ===== */
    var swatchBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mp-swatch]'));
    var sizeBtns   = Array.prototype.slice.call(root.querySelectorAll('[data-mp-size]'));
    var heightBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mp-height]'));

    var stoneIdx  = parseInt(root.dataset.stoneIdx  || '0', 10);
    var sizeIdx   = parseInt(root.dataset.sizeIdx   || '0', 10);
    var heightIdx = parseInt(root.dataset.heightIdx || '0', 10);

    var hasStone  = swatchBtns.length > 0 && stoneIdx > 0;
    var hasSize   = sizeBtns.length   > 0 && sizeIdx  > 0;
    var hasHeight = heightBtns.length > 0 && heightIdx > 0;

    function vopt(v, idx) {
      if (idx === 1) return v.option1;
      if (idx === 2) return v.option2;
      if (idx === 3) return v.option3;
      return null;
    }

    var selected = {
      stone:  hasStone  ? (root.querySelector('[data-mp-swatch].is-selected')  || swatchBtns[0]).dataset.mpValue : null,
      size:   hasSize   ? (root.querySelector('[data-mp-size].is-selected')    || sizeBtns[0]).dataset.mpValue   : null,
      height: hasHeight ? (root.querySelector('[data-mp-height].is-selected')  || heightBtns[0]).dataset.mpValue : null
    };
    var lastStoneGroup = null;

    function variantMatches(v, stone, size, height) {
      if (hasStone  && vopt(v, stoneIdx)  !== stone)  return false;
      if (hasSize   && vopt(v, sizeIdx)   !== size)   return false;
      if (hasHeight && vopt(v, heightIdx) !== height) return false;
      return true;
    }

    function findVariant(stone, size, height) {
      for (var i = 0; i < variants.length; i++) {
        if (variantMatches(variants[i], stone, size, height)) return variants[i];
      }
      return null;
    }

    function minPriceWhere(predicate) {
      var min = null;
      variants.forEach(function (v) {
        if (predicate(v) && (min === null || v.price < min)) min = v.price;
      });
      return min;
    }

    /* DOM refs */
    var variantInput     = root.querySelector('[data-mp-variant-id]');
    var totalEl          = root.querySelector('[data-mp-total]');
    var totalCompareEl   = root.querySelector('[data-mp-total-compare]');
    var fromPriceEl      = root.querySelector('[data-mp-from-price]');
    var fromCompareEl    = root.querySelector('[data-mp-from-compare]');
    var stoneNameEl      = root.querySelector('[data-mp-stone-name]');
    var stoneDeltaEl     = root.querySelector('[data-mp-stone-delta]');
    var atcBtn           = root.querySelector('#AddToCart');
    var atcText          = root.querySelector('[data-mp-atc-text]');
    var availabilityEl      = root.querySelector('[data-mp-availability]');
    var availabilityDotEl   = root.querySelector('[data-mp-availability-dot]');
    var availabilityTitleEl = root.querySelector('[data-mp-availability-title]');
    var availabilityEtaEl   = root.querySelector('[data-mp-availability-eta]');

    var globalMin = minPriceWhere(function () { return true; });

    function variantInStock(v) {
      if (!v) return false;
      if (root.dataset.readyToShip !== 'true') return false;
      var mapped = inventoryMap[v.id];
      var qty = mapped ? (mapped.qty || 0) : (v.inventory_quantity || 0);
      return qty > 0 && qty < 999;
    }

    function deltaLabel(cents) {
      if (cents == null || cents <= 0) return '';
      return '+' + formatMoney(cents, moneyFormat);
    }

    /* ===== REFRESH ===== */
    function refresh() {
      var v = findVariant(selected.stone, selected.size, selected.height);

      /* selected-state classes */
      swatchBtns.forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.mpValue === selected.stone);
      });
      sizeBtns.forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.mpValue === selected.size);
      });
      heightBtns.forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.mpValue === selected.height);
      });

      /* swap gallery image group when stone changes */
      if (hasStone) {
        var stoneGroup = handleize(selected.stone);
        if (stoneGroup !== lastStoneGroup) {
          setImageGroup(stoneGroup);
          lastStoneGroup = stoneGroup;
        }
      }

      /* stone name + delta vs cheapest stone */
      if (stoneNameEl) stoneNameEl.textContent = selected.stone || '';
      if (stoneDeltaEl && hasStone) {
        var stoneMin = minPriceWhere(function (vr) { return vopt(vr, stoneIdx) === selected.stone; });
        var sd = (stoneMin != null && globalMin != null) ? stoneMin - globalMin : null;
        stoneDeltaEl.textContent = (sd && sd > 0) ? deltaLabel(sd) : '';
      }

      /* size card stock dots */
      if (hasSize) {
        sizeBtns.forEach(function (b) {
          var sv = findVariant(selected.stone, b.dataset.mpValue, selected.height);
          var dot = b.querySelector('[data-mp-size-stock-dot]');
          if (dot) {
            if (variantInStock(sv)) {
              dot.removeAttribute('hidden');
              b.classList.add('has-stock');
            } else {
              dot.setAttribute('hidden', 'hidden');
              b.classList.remove('has-stock');
            }
          }
        });
      }

      /* height / count pill stock dots */
      if (hasHeight) {
        heightBtns.forEach(function (b) {
          var hv = findVariant(selected.stone, selected.size, b.dataset.mpValue);
          var dot = b.querySelector('[data-mp-height-stock-dot]');
          if (dot) {
            if (variantInStock(hv)) {
              dot.removeAttribute('hidden');
              b.classList.add('has-stock');
            } else {
              dot.setAttribute('hidden', 'hidden');
              b.classList.remove('has-stock');
            }
          }
        });
      }

      /* price + ATC */
      if (v) {
        if (totalEl) totalEl.textContent = formatMoney(v.price, moneyFormat);
        if (totalCompareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            totalCompareEl.textContent = formatMoney(v.compare_at_price, moneyFormat);
            totalCompareEl.removeAttribute('hidden');
          } else {
            totalCompareEl.textContent = '';
            totalCompareEl.setAttribute('hidden', 'hidden');
          }
        }

        /* "from" price in the header updates to the currently selected variant */
        if (fromPriceEl) fromPriceEl.textContent = formatMoney(v.price, moneyFormat);
        if (fromCompareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            fromCompareEl.textContent = formatMoney(v.compare_at_price, moneyFormat);
            fromCompareEl.removeAttribute('hidden');
          } else {
            fromCompareEl.textContent = '';
            fromCompareEl.setAttribute('hidden', 'hidden');
          }
        }

        if (variantInput) variantInput.value = v.id;

        if (atcBtn) {
          atcBtn.removeAttribute('disabled');
          atcBtn.classList.remove('sold-out');
          if (atcText) atcText.textContent = root.dataset.atcLabel || atcText.textContent || 'Add to cart';
        }

        /* availability banner */
        if (availabilityEl) {
          var inStock = variantInStock(v);
          if (inStock) {
            availabilityEl.classList.remove('mp-availability--mto');
            availabilityEl.classList.add('mp-availability--stock');
            if (availabilityDotEl) {
              availabilityDotEl.classList.remove('mp-availability__dot--mto');
              availabilityDotEl.classList.add('mp-availability__dot--in-stock');
            }
            if (availabilityTitleEl) availabilityTitleEl.textContent = root.dataset.statusInStock || 'In stock';
            if (availabilityEtaEl)   availabilityEtaEl.textContent   = root.dataset.statusInStockEta || '';
          } else {
            availabilityEl.classList.remove('mp-availability--stock');
            availabilityEl.classList.add('mp-availability--mto');
            if (availabilityDotEl) {
              availabilityDotEl.classList.remove('mp-availability__dot--in-stock');
              availabilityDotEl.classList.add('mp-availability__dot--mto');
            }
            if (availabilityTitleEl) availabilityTitleEl.textContent = root.dataset.statusMadeToOrder || 'Made to order';
            if (availabilityEtaEl)   availabilityEtaEl.textContent   = root.dataset.statusMadeToOrderEta || '';
          }
          availabilityEl.removeAttribute('hidden');
        }
      } else {
        if (totalEl) totalEl.textContent = '—';
        if (availabilityEl) availabilityEl.setAttribute('hidden', 'hidden');
        if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
      }
    }

    /* event listeners */
    swatchBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        selected.stone = b.dataset.mpValue;
        refresh();
      });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        selected.size = b.dataset.mpValue;
        refresh();
      });
    });
    heightBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        selected.height = b.dataset.mpValue;
        refresh();
      });
    });

    /* initial paint */
    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-accessory-product]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', boot);
})();
